import {
  ApartmentOutlined,
  HomeOutlined,
  MessageOutlined,
  ReadOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import * as React from "react";
import { appStore } from "src/appStore";
import { WorkflowIcon } from "src/icons";
import { PageUrl } from "src/routes/PageUrl";

import { LeftMenuItem } from "./LeftMenuItem";

export const leftMenuItems: LeftMenuItem[] = [
  {
    key: "home",
    label: "Главная",
    type: "link",
    url: PageUrl.home,
    icon: <HomeOutlined />,
  },
  {
    key: "workflowStreams",
    label: "Рабочие потоки и версии",
    type: "link",
    icon: <WorkflowIcon />,
    url: PageUrl.workflowStreams,
  },
  {
    key: "catalogs",
    label: "Каталоги",
    type: "link",
    icon: <ReadOutlined />,
    url: PageUrl.catalogs,
  },
  {
    key: "classifiers",
    label: "Классификаторы",
    type: "link",
    url: PageUrl.classifiers,
    icon: <ApartmentOutlined />,
  },
  {
    key: "management",
    label: "Управление",
    type: "group",
    icon: <SettingOutlined />,
    hidden: () => !appStore.isMetadataEditor,
    items: [
      {
        key: "management/objects",
        label: "Объекты и спецификации",
        type: "link",
        url: PageUrl.managementCatalogs,
      },
      {
        key: "management/users",
        label: "Пользователи и роли",
        type: "link",
        url: PageUrl.managementUsers,
      },
      {
        key: "management/workflows",
        label: "Рабочие потоки",
        type: "link",
        url: PageUrl.managementWorkflows,
      },
      {
        key: "management/extensions",
        label: "Расширения",
        type: "link",
        url: PageUrl.managementExtensions,
      },
      {
        key: "docs",
        label: "Структура данных",
        type: "link",
        url: PageUrl.docs,
      },
    ],
  },
  {
    key: "techsupport",
    label: "Тех. поддержка",
    type: "external",
    url: "https://support",
    icon: <MessageOutlined />,
  },
];
